import AccountIcon from "assets/images/icon/icon-account.svg";
import ArrowBackIcon from "assets/images/svg/ic_arrow_back_24px.svg";
import ArrowDownIcon from "assets/images/svg/ic_keyboard_arrow_down_24px.svg";
import ArrowUpIcon from "assets/images/svg/ic_keyboard_arrow_up_24px.svg";
import AccountInfoIcon from "assets/images/svg/accountInfo_icon.svg";
import ChevronRightIcon from "assets/images/svg/ic_chevron_right_24px.svg";
import ChevronLeftIcon from "assets/images/svg/ic_chevron_left_24px.svg";
import DeleteIcon from "assets/images/icon/delete.svg";
import CameraIcon from "assets/images/svg/claim_camera.svg";
import CloseIcon from "assets/images/svg/ic_close_24px.svg";
import FileDownloadIcon from "assets/images/svg/ic_file_download_24px.svg";
import FileImageIcon from "assets/images/svg/ic_file_image_24px.svg";
import FilePdfIcon from "assets/images/svg/ic_file_pdf_24px.svg";
import FileUnknownIcon from "assets/images/svg/ic_file_unknown_24px.svg";
import FilterIcon from "assets/images/svg/icon-filter.svg";
import HelpOutlineIcon from "assets/images/svg/ic_help_outline_24px.svg";
import InfoOutlineIcon from "assets/images/svg/ic_info_outline_24px.svg";
import PrintIcon from "assets/images/svg/ic_print_24px.svg";
import RemoveCircleIcon from "assets/images/svg/ic_remove_circle_24px.svg";
import RemoveCircleOutlineIcon from "assets/images/svg/ic_remove_circle_outline_24px.svg";
import SearchIcon from "assets/images/svg/ic_search_24px.svg";
import ShoppingCartIcon from "assets/images/icon/icon-cart.svg";
import SortIcon from "assets/images/svg/icon-sort.svg";
import WordingDownloadIcon from "assets/images/svg/icon-wording-download.svg";
import WorksiteFamilyIcon from "assets/images/svg/icon-worksite-family.svg";
import PaperClipIcon from "assets/images/svg/icon-paperclip.svg";

export {
  AccountIcon,
  ArrowBackIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  AccountInfoIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  DeleteIcon,
  CameraIcon,
  CloseIcon,
  FileDownloadIcon,
  FilePdfIcon,
  FileImageIcon,
  FileUnknownIcon,
  FilterIcon,
  HelpOutlineIcon,
  InfoOutlineIcon,
  PrintIcon,
  RemoveCircleIcon,
  RemoveCircleOutlineIcon,
  ShoppingCartIcon,
  SearchIcon,
  SortIcon,
  WordingDownloadIcon,
  WorksiteFamilyIcon,
  PaperClipIcon,
};



// WEBPACK FOOTER //
// ./components/common/icons.js